import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { ProductDecoration } from '@app/shared/models/decoration-type.model';

@Injectable({ providedIn: 'root' })
export class DecorationTypeService {

  constructor(private http: HttpClient) { }

  /**
   * Fetch the decoration options for a given product (by Product.ProductId = the EF PK).
   * Auth headers are added automatically by the HTTP interceptor.
   * @param productId  Product.ProductId (EF PK), NOT UniqueID.
   * @param storeId    Optional store id for per-store rate resolution.
   */
  getProductDecorations(productId: number, storeId?: number): Observable<ProductDecoration[]> {
    let url = `${environment.baseUrl}/Product/GetProductDecorations?productId=${productId}`;
    if (storeId != null) {
      url += `&storeId=${storeId}`;
    }
    return this.http.get<any>(url).pipe(
      map(res => (res && res.Data && res.Data.ResponseData) ? res.Data.ResponseData as ProductDecoration[] : [])
    );
  }

  /**
   * Fetch the global decoration-type lookup (super-admin context).
   * Auth headers are added automatically by the HTTP interceptor.
   * Returns all active decoration types (DecorationTypeId, Name, Code).
   */
  getDecorationTypes(): Observable<{ DecorationTypeId: number; Name: string; Code?: string }[]> {
    const url = `${environment.baseUrl}/api/product-management/decoration-types-lookup`;
    return this.http.get<any>(url).pipe(
      map(res => (res && res.Data && res.Data.ResponseData) ? res.Data.ResponseData as { DecorationTypeId: number; Name: string; Code?: string }[] : [])
    );
  }
}
